<template>
  <div class="content">
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <div class="card">
<!--          <div class="card-header">-->
<!--            <h4 class="card-title pull-left">-->
<!--              Reminders-->
<!--            </h4>-->
<!--            </div>-->
          <div class="card-body mt-0 pt-0">
            <div class="row">
              <h4 class="card-title ml-3">
                Reminders
              </h4>
            </div>
            <div class="row">
              <div class="col-md-9">
                <button @click="getReminders" :disabled="loading" class="btn btn-primary pull-left">
                  <i class="fa fa-refresh mr-1" aria-hidden="true"></i>Sync
                </button>
              </div>
              <div class="col-md-3">
                <button data-toggle="modal"  @click="fixModal" data-target="#reminderModal" class="btn btn-outline-primary pull-right">Set reminder</button>
              </div>

            </div>
            <div class="loader" v-if="loading"></div>
            <table class="table table-striped table-bordered reminder-datatable" v-else>
              <thead>
              <tr>
                <th>Domain</th>
                <th class="text-center">Email</th>
                <th class="text-center">Text</th>
                <th class="text-center">Due Date</th>
                <th class="text-center">Created At</th>
                <th class="text-center">Status</th>
                <th class="text-center">Acknowledged At</th>
                <th class="text-center">Acknowledged By</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="row in reminders" :key="row.id">
                <td style="width: 120px">
                  <span>{{row.domain}}</span>
                </td>
                <td style="width: 120px" class="text-center">
                  {{row.email}}
                </td>
                <td style="width: 200px">{{parseText(row.text)}}</td>
                <td style="width: 70px" class="text-center">{{(row.originalDueDate) | formatDate}}</td>
                <td style="width: 70px" class="text-center">{{row.created_at | formatDate}}</td>
                <td style="width: 70px" class="text-center">{{ row.status }}</td>
                <td style="width: 100px" class="text-center"> <span v-if="row.ack_at">{{row.ack_at | formatDate}}</span></td>
                <td style="width: 100px" class="text-center"><span v-if="row.ack_by">{{row.ack_by}}</span></td>
                <td style="width: 110px" class="text-center">
                  <button :disabled="row.status==='completed'" class="btn btn-sm btn-outline-primary mr-2" @click="openEditModal(row)"><i class="fa fa-pencil"></i></button>
                  <button class="btn btn-sm btn-outline-danger" @click="deleteReminder(row)"><i class="fa fa-times"></i></button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="reminder-modal position-relative">
      <div class="modal fade reminderModal" id="reminderModal" tabindex="-1" role="dialog" aria-labelledby="reminderModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Add Reminder</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form action="" @submit.prevent="submit">

            <div class="modal-body">
              <div class="form-group">
                <label>Who is this reminder for?</label>
                <multiselect required v-model="formData.selectedUser" :options="slackUsers" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Select user" label="name" track-by="value" :preselect-first="false">
                </multiselect>
              </div>
              <div class="form-group">
                <label>Text</label>
                <textarea id="mix" name='mix'></textarea>
              </div>
              <div class="form-group">
                <label>Email</label>
                <input type="text" v-model="formData.email" class="form-control" required >
              </div>
              <div class="form-group">
                <label>Domain</label>
                <input type="text" v-model="formData.domain" class="form-control" required >
              </div>
              <div class="form-group">
                <label>Due Date (EST)</label>
                <input type="datetime-local"  v-model="formData.due_date" class="form-control" :min="getCurrentTime" required >
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button v-if="type==='edit'" type="submit" class="btn btn-primary" :disabled="loading">
                <div class="loader small_loader" v-if="loading"></div>
                <span @click="type='edit'" v-else>Update</span>
              </button>

              <button v-else type="submit" class="btn btn-primary" :disabled="loading">
                <div class="loader small_loader" v-if="loading"></div>
                <span @click="type='add'" v-else>Submit</span>
              </button>
            </div>
            </form>

          </div>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
import swal from "sweetalert2";
import {db} from "@/firebase/init";
import Tagify from '@yaireo/tagify'
import '@yaireo/tagify/dist/tagify.css'
import Multiselect from 'vue-multiselect'
import moment from 'moment-timezone';
export default {
  name: "reminders",
  components: {
    Multiselect
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  data(){
    return {
      selectedUser: null,
      loading: false,
      formData: {},
      reminders: [],
      slackUsers: [],
      selectedTags: [],
      type: 'add',
    }
  },
  mounted(){
    this.timeDiffBetweenEstAndUtc()
    this.getReminders()
    this.getSlackUsers()
    this.initiateTagify()
  },
  methods: {
    timeDiffBetweenEstAndUtc() {
      const est = new Date(this.getCurrentTime());
      const date = new Date();
      const offset = date.getTimezoneOffset();
      const utc = new Date(date.getTime() + offset * 60000);
      const timeDifferenceMs = utc - est
      return timeDifferenceMs / (1000 * 60 * 60);
    },
    getCurrentTime(){
      let now = new Date();
      const easternTime = now.toLocaleString('en-US', {
        timeZone: 'America/New_York',
      });
      let finalDate=moment(easternTime).format("YYYY-MM-DDTkk:mm")
      console.log('final date', finalDate)
      return finalDate;
      },
    openEditModal(row){
      this.type='edit'
      this.formData=JSON.parse(JSON.stringify(row))
      this.formData.due_date=this.formData.originalDueDate
      // parse text
      let text=this.formData.text.split(' ')
      let array=[]
      text.map(el => {
        if(el.startsWith('<')){
          let obj= this.slackUsers.find(row => row.id===el)
          console.log('obj', obj)
          if(obj){
            this.selectedTags.push(obj)
            console.log('tags', this.selectedTags)
            array.push(`[[${obj.value}]]`)
          }else{
            array.push(el)
          }
        }else{
          array.push(el)
        }
      })
      this.formData.text=array.join(' ')
      $('#mix').val(this.formData.text);
      $('#reminderModal').modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");

    },
    deleteReminder(row){
      try{
        swal({
          title: "Delete Reminder",
          text: "Are you sure to delete reminder?",
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057"
        }).then(async result =>  {
          if(result.value){
            const resp=await this.$reminderService.post('/schedular/delete-reminder', {
              grant_type: 'token',
              id: row.id
            })
            await this.getReminders()
            this.loading=false
            swal({
              title: "Success",
              text: "You have successfully deleted reminder " ,
              type: "success",
            });
          }
        }).catch((err)=>{
          this.loading=false
          swal({
            title: "Error",
            text: "Error while deleting reminder" ,
            type: "error",
          });
        });
      }
      catch(err){
        this.loading=false
        swal({
          title: "Error",
          text: "Error while un-assigning nodes " ,
          type: "error",
        });
        $('#nodesModal').modal('hide');
      }
    },
    async initiateTagify(){
      let self=this
      self.selectedTags=[]
      // initialize Tagify
      const input = document.querySelector('[name=mix]'),
          tagify = new Tagify(input, {
            mode: 'mix',
            pattern: /@|#/,
            tagTextProp: 'value',
            whitelist: self.slackUsers.map(function(item){
              return  item
            }),
            dropdown : {
              enabled: 1,
              position: 'value',
              mapValueTo: 'name',
              highlightFirst: true
            },
            callbacks: {
              add: console.log,
              remove: console.log
            }
          })
      tagify.on('input', function(e){
        var prefix = e.detail.prefix;
        if( prefix ){
          if( prefix == '@' )
            tagify.whitelist = self.slackUsers;

          if( e.detail.value.length > 1 )
            tagify.dropdown.show(e.detail.value);
        }
        console.log('tagofy ', tagify.value)
        self.selectedTags=self.selectedTags.concat(tagify.value)
        self.formData.text=e.detail.textContent
      })

      tagify.on('remove', function(e){
        console.log(e)
        console.log(self.formData.text)
        self.formData.text=self.formData.text.replace(`[[${e.detail.data.value}]]`, '')
      })
    },
    async getSlackUsers(){
      try{
        this.loading=true
        this.slackUsers=[]
        const resp=await this.$reminderService.post('/schedular/get-slack-users', {
          grant_type: 'token',
          data: this.formData
        })
        this.slackUsers=resp.data.members
      }catch(e){
        console.log(e.toString())
      }finally {
        this.loading=false

      }
    },
    async getReminders(){
      try{
        this.loading=true
        this.reminders=[]
        $(".reminder-datatable").DataTable().destroy();
        let ref=await db.collection('reminders')
            .orderBy("created_at", "desc")
            .get();
        if(ref.size>0){
          ref.forEach(el => {
            this.reminders.push({id: el.id, ...el.data()})
          })
        }
        setTimeout(function () {
          $(".reminder-datatable").DataTable({
            ordering: false,
            retrieve: true,
            language: {
              search: "_INPUT_",
              searchPlaceholder: "Search Reminder",
              emptyTable: "No reminder exist in the system",
              size: '40'
            }
          });

        },200)
      }catch(e){
        this.reminders=[]
        console.log(e.toString())
      }finally {
        this.loading=false
      }
    },
    fixModal() {
      /* eslint-disable */
      this.loading=false
      this.type='add'
      this.formData={}
      this.formData.due_date= this.getCurrentTime()
      $('#mix').val('');
      $(document).ready(function() {
        $(".modal-backdrop").appendTo(".reminder-modal");
      });
    },
    parseText(val){
      let text= val.split(' ')
      let modifiedArray=[]
      for(const row of text){
        let obj= this.slackUsers.find(el => el.id===row)
        if(obj){
          modifiedArray.push(obj.name)
        }else{
          modifiedArray.push(row)
        }
      }
      return modifiedArray.join(' ')
    },
    async submit(){
      try {
        this.loading=true;
        let extraInfoAboutDates = {
          timeDiffBetweenEstAndUtc: 0,
          dateAfterAddingDiff: '',
          prevDate: '',
          afterReducingMinutesInPrevDate: ''
        }
        // backend time is in utc
        this.formData.originalDueDate= this.formData.due_date
        console.log('original date', this.formData.originalDueDate)
        // this.formData.due_date = new Date(this.formData.due_date).toISOString()
        let date  = new Date(this.formData.due_date)

        const diff = await this.timeDiffBetweenEstAndUtc();
        extraInfoAboutDates.timeDiffBetweenEstAndUtc = diff;


        date.setHours(date.getHours() + diff)
        extraInfoAboutDates.dateAfterAddingDiff = date


        let prevDate= new Date(date)
        extraInfoAboutDates.prevDate = prevDate
        prevDate.setMinutes(prevDate.getMinutes() - 5);
        extraInfoAboutDates.afterReducingMinutesInPrevDate = prevDate
        // this.formData.modifiedDate=`${date.getFullYear()}, ${date.getMonth()}, ${date.getDate()},  ${date.getHours()},  ${date.getMinutes()},  ${date.getSeconds()}`

        this.formData.due_date=`${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
        console.log(this.formData.due_date)
        // this.formData.due_date= date
        let text= this.formData.text.split(' ')
        console.log(text)
        console.log(this.selectedTags)
        let modifiedArray=[]
        for(const row of text){
          let obj={}
          if(this.type==='edit'){
            let text=((row.replaceAll('[[', '').replaceAll(']]', '')))
            console.log(text)
            obj= this.selectedTags.find(el => el.value===text.trim())
          }else{
            obj= this.selectedTags.find(el => el.value===(row.trim()))
          }
          if(obj){
            modifiedArray.push(obj.id)
          }else{
            modifiedArray.push(row)
          }
        }
        console.log(modifiedArray)
        // this.formData.originalDueDate= this.formData.due_date
        // this.formData.due_date = new Date(this.formData.due_date).toISOString()
        this.formData.text=modifiedArray.join(' ')
        // this.formData.modifiedPrevDate=`${prevDate.getFullYear()}, ${prevDate.getMonth()}, ${prevDate.getDate()},  ${prevDate.getHours()},  ${prevDate.getMinutes()},  ${prevDate.getSeconds()}`
        this.formData.prevDate=`${prevDate.getFullYear()}-${prevDate.getMonth()+1}-${prevDate.getDate()} ${prevDate.getHours()}:${prevDate.getMinutes()}:${prevDate.getSeconds()}`
        console.log('this.formData')
        console.log(this.formData)
        if(this.type==='edit'){
          await this.$reminderService.post('/schedular/update-reminder', {
            grant_type: 'token',
            data: this.formData,
            extraInfoAboutDates
          })
        }else{
          this.formData.createdBy = `${this.user.firstName} ${this.user.lastName}`
          await this.$reminderService.post('/schedular/set-reminder', {
            grant_type: 'token',
            data: this.formData,
            extraInfoAboutDates
          })
        }
        await this.getReminders()
        this.loading=false;

        $('#reminderModal').modal('hide');
        this.formData={}

        swal({
          title: "Success",
          text: "You have successfully set up reminder!",
          type: "success",
        });
      }
      catch(err){
        console.log('error', err)
        this.loading=false;
        this.type='add'
        swal({
          title: "Error",
          text: "Error while setting reminder " ,
          type: "error",
        });
      }
    }
  }
}
</script>

<style scoped>
input[type="datetime-local"]::-webkit-calendar-picker-indicator {
  background: transparent;
  bottom: 0;
  color: transparent;
  cursor: pointer;
  height: auto;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: auto;
}
td{
  word-break: break-all;
}
</style>
